import { createApp } from "vue";
import InputSearch from "../components/InputSearch";
import Utils from "./Utils";

export default class Program {
    private $wrap: JQuery;
    private $el: JQuery;
    private $groups: JQuery;
    private $items: JQuery;

    private $dates: JQuery;
    private $rooms: JQuery;

    private date: number;
    private room: number;

    private query: string | null;

    public constructor() {
        this.initHtml();
    }

    private getDefaultDate(): number {
        let date = new Date();

        const parts = Utils.getHashParts();

        if (parts.has('date')) {
            date = new Date(parts.get('date'));
        }

        const now = Math.round(date.getTime() / 1000);
        const day = 24 * 60 * 60;

        let result: number = now;

        $(this.$dates.get().reverse()).each((ix, el) => {
            const date = $(el).data('date');

            if (result == now) {
                result = date;
            }

            if (date + day < now) {
                return false;
            }

            result = date;
        });

        return result;
    }

    public findQuery(text: string, query: string): boolean {
        text = text.toLowerCase();

        const tags = query.split(/\s/);

        for (let tag of tags) {
            tag = tag.trim();

            if (tag == '') {
                continue;
            }

            if (!text.includes(tag)) {
                return false;
            }
        }

        return true;
    }

    private updateItems(force?: boolean): void {
        const hasquery = this.query != null && this.query.length > 0;
        const query = hasquery ? this.query.toLowerCase() : null;

        const itemFoundFunc = ($item: JQuery, found: boolean)  => {
            if (found != null) {
                $item.toggleClass('eventprogramlist__item--found', found);
                $item.toggleClass('eventprogramlist__item--notfound', !found);
            } else {
                $item.removeClass('eventprogramlist__item--found eventprogramlist__item--notfound');
            };
        }

        this.$groups.each((ix, el) => {
            let $group = $(el);

            if ($group.data('date') == this.date && $group.data('room') == this.room) {
                Utils.toggle($group, true, force);
            } else {
                Utils.toggle($group, false, force);
            }

            const $items = $('.eventprogramlist__item', $group);
            const $first = $items.first();

            let found: boolean = hasquery ? false : null;

            $items.each((ix2, el2) => {
                let $item = $(el2);
                const founditem = hasquery ? this.findQuery($item.text(), query) : null;

                itemFoundFunc($item, founditem);

                if (founditem) {
                    found = true;
                }
            });

            itemFoundFunc($first, found);
        });

        this.$rooms.each((ix, el) => {
            let $room = $(el);
            let room = $room.data('room');

            let $result = this.$groups.filter('[data-date="' + this.date + '"][data-room="' + room + '"]');
            let found: boolean = $result.length > 0;

            if (found && hasquery) {
                const $items = $('.eventprogramlist__item--found', $result);

                found = $items.length > 0;
            }

            $room.toggleClass('eventprogramroomselector__item--found', found);
        });
    }

    private getDateEl(date: number): JQuery {
        if (date == null) {
            return this.getDateEl(this.getDefaultDate());
        }

        let $result = null;

        this.$dates.each((ix, el) => {
            let $date = $(el);

            if ($date.data('date') == date) {
                $result = $date;
                return true;
            }
        });

        return $result;
    }

    private getRoomEl(room: number): JQuery {
        if (room == null) {
            return this.$rooms.filter('.eventprogramroomselector__item--found').first();
        }

        let $result = null;

        this.$rooms.each((ix, el) => {
            let $room = $(el);

            if ($room.data('room') == room) {
                $result = $room;
                return true;
            }
        });

        return $result;
    }

    private setDate(date: number, force?: boolean): void {
        if (date == null) {
            date = this.getDefaultDate();
        }

        let $date = this.getDateEl(date);

        this.$dates.removeClass('eventprogramdateselector__item--selected');

        if ($date != null) {
            $date.addClass('eventprogramdateselector__item--selected');
        }

        this.date = date;

        this.updateItems(true);

        let $room = this.getRoomEl(null);
        let room = $room != null ? $room.data('room') : null;

        this.setRoom(room, force);
    }

    private setRoom(room: number, force?: boolean): void {
        let $room = this.getRoomEl(room);

        if (room == null) {
            room = $room.data('room');
        }

        this.$rooms.removeClass('eventprogramroomselector__item--selected');

        if ($room != null) {
            $room.addClass('eventprogramroomselector__item--selected');
        }

        this.room = room;

        this.updateItems(force);

        this.$wrap.toggleClass('vevent__program--one-date', this.$dates.length < 2);
        this.$wrap.toggleClass('vevent__program--one-room', this.$rooms.filter('.eventprogramroomselector__item--found').length < 2);
    }

    private setFilter(query: string): void {
        this.query = query;

        this.updateItems(true);

        if (this.query == null) {
            this.setRoom(null, true);
        }
    }

    public initHtmlProgram(): void {
        this.$groups = $('.eventprogramlist__group', this.$el);
        this.$items = $('.eventprogramlist__item', this.$el);

        const collapsed = this.$wrap.data('collapse');
        const now = Math.round(new Date().getTime() / 1000);

        this.$groups.each(function () {
            const $group = $(this);
            const $items = $('.eventprogramlist__item', $group);
            const $nexts = $items.not(':first');

            function toggle(visible: boolean, force?: boolean): void {
                $group.toggleClass('eventprogramlist__group--closed', !visible);
                $group.toggleClass('eventprogramlist__group--opened', visible);

                Utils.toggle($nexts, visible, force);
            }

            $items.each(function () {
                const $item = $(this);
                const main = $item.hasClass('eventprogram--main');

                if (main) {
                    const $switch = $('.eventprogram__switcher', $item);

                    $switch.click(() => {
                        const vis = $group.hasClass('eventprogramlist__group--opened');
                        toggle(!vis);
                    });

                    const from: number = $item.data('from');
                    const to: number = $item.data('to');

                    const current = now >= from && now <= to;

                    let c = false;

                    switch (collapsed) {
                        case 1:
                            c = true;
                            break;

                        case 2:
                            c = collapsed && current;
                            break;
                    }

                    toggle(c, true);
                }
            });
        });
    }

    public initHtmlDates(): void {
        this.$dates = $('.eventprogramdateselector__item');

        this.$dates.each((ix, el) => {
            let $date = $(el);

            $date.click((e) => {
                e.preventDefault();

                this.setDate($date.data('date'));
            });
        });
    }

    public initHtmlRooms(): void {
        this.$rooms = $('.eventprogramroomselector__item');

        this.$rooms.each((ix, el) => {
            let $room = $(el);

            $room.click((e) => {
                e.preventDefault();

                this.setRoom($room.data('room'));
            });
        });
    }

    private initHtmlSearch(): void {
        const $search = $('.eventprogramselectors__search');

        const This = this;

        createApp({
            components: {
                InputSearch,
            },

            data() {
                return {
                    query: null,
                };
            },

            watch: {
                query(v) {
                    This.setFilter(v);
                },
            },
        }).mount($search[0]);

        This.setFilter(null);
    }

    public initHtml(): void {
        let This = this;

        this.$wrap = $('.vevent__program');
        this.$el = $('.eventprogramlist');

        this.initHtmlProgram();
        this.initHtmlDates();
        this.initHtmlRooms();
        this.initHtmlSearch();

        this.setDate(null, true);
        this.setRoom(null, true);

        this.$el.addClass('eventprogramlist--inited');
        this.$wrap.addClass('vevent__program--inited');
    }
}
